import React from 'react';
import { Datagrid, DeleteButton, List, TextField } from 'react-admin';

import * as AccessCheck from '../../Common/Utils/AccessCheck';
import DateField from '../../Common/Utils/DateField';
import DefaultSort from '../../Common/Partials/DefaultSort';
import RequiredRole from './StaticData/RequiredRole';
import SearchFilter from './Helpers/SearchFilter';
import TeamTitleName from './StaticData/TitleName';

type Props = {
  permissions: any,
  record: any,
  resource: string
};

const TeamList = (props: Props) => (
  <List filters={<SearchFilter />} title={TeamTitleName} sort={DefaultSort} perPage={25} bulkActionButtons={false} {...props}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <DateField name="updated_at" source="updated_at" />
      {AccessCheck.Delete(props.permissions, RequiredRole, <DeleteButton />)}
    </Datagrid>
  </List>
);

export default TeamList;



// WEBPACK FOOTER //
// ./src/views/Components/Teams/List.tsx